module.exports = __webpack_public_path__ + "img/FR.f64380d7.svg";